import  "./Home.css"
import Navbar from "../../components/navbar/Navbar"
import Slide from "../../components/slide/Slide"
import About from "../../components/About/About"
import Services from "../../components/services/Services"
import Projects from "../../components/projects/Projects"
import Contact from "../../components/contact/Contact"
import Footer from "../../components/footer/Footer"



const Home = () => {


  return (
    <div className="home">
      <Navbar/>
      <Slide/>
      <div className="homeLine">
        <hr className="line"  id="about"/>
        <h3 className="topic">About Us</h3>
      </div>
       <About  data-aos="zoom-in"/>
       <div className="homeLine">
         <hr className="line" id="services"/>
         <h3 className="topic">Services we offer</h3>
       </div>
      <Services/>
      <div className="homeLine">
         <hr className="line"  id="projects"/>
         <h3 className="topic">Some of our projects</h3>
       </div>
       <Projects/>
       <div className="homeLine">
         <hr className="line" id="contact"/>
         <h3 className="topic">contact us</h3>
       </div>
       <Contact/>
       <Footer/>
      
    </div>
  )
}

export default Home